import { useEffect, useState } from "react";
import { FaCamera } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {
  formatPhotoCaptureStatus,
  isPhotoSideEnabled,
} from "./installationConfigUtils";
import {
  InstallationPickerOption,
  InstallationPickerRow,
  InstallationPickerSheet,
} from "./InstallationPickerSheet";

const InstallationPhotoCaptureSection = ({
  configData,
  side,
  onPhotoSave,
  divided,
  disabled,
  saving,
}) => {
  const { t } = useTranslation();
  const [sheetOpen, setSheetOpen] = useState(false);
  const enabled = isPhotoSideEnabled(configData, side);
  const [draftEnabled, setDraftEnabled] = useState(enabled);

  useEffect(() => {
    if (sheetOpen) {
      setDraftEnabled(enabled);
    }
  }, [sheetOpen, enabled]);

  const isDirty = draftEnabled !== enabled;

  const closeSheet = () => {
    setDraftEnabled(enabled);
    setSheetOpen(false);
  };

  const handleSave = async () => {
    const saved = await onPhotoSave(side, draftEnabled);
    if (saved) {
      setSheetOpen(false);
    }
  };

  return (
    <>
      <InstallationPickerRow
        icon={FaCamera}
        iconVariant="photo-capture"
        title={t("installation_side_hub_photo")}
        subtitle={formatPhotoCaptureStatus(t, configData, side)}
        onClick={() => setSheetOpen(true)}
        disabled={disabled || saving}
        divided={divided}
      />

      <InstallationPickerSheet
        open={sheetOpen}
        title={t("installation_picker_title_photo")}
        dirty={isDirty}
        saving={saving}
        onDismiss={closeSheet}
        onSave={() => void handleSave()}
      >
        <InstallationPickerOption
          label={t("installation_photo_active")}
          selected={draftEnabled === true}
          onSelect={() => setDraftEnabled(true)}
        />
        <InstallationPickerOption
          label={t("installation_photo_inactive")}
          selected={draftEnabled === false}
          onSelect={() => setDraftEnabled(false)}
        />
      </InstallationPickerSheet>
    </>
  );
};

export default InstallationPhotoCaptureSection;
